import React from 'react';
const Footer = () => {
    return (
        <div className="section-container color white" style={{ 'height': '120px', 'textAlign': 'center', "marginTop": "0px" }}>
            <p className='white'>Feito com <span style={{ 'color': 'red' }}> &hearts; </span> Odisseia Desenvolvimento Profissional</p>
        </div>
    );
};

export default Footer;
